<template>
	<button
		:disabled="isDisabled"
		:class="[
			{
				'won-green-button-color-disabled': isDisabled,
			},
			{
				'won-button-ghost': ghost,
			},
			{
				'won-button-upload': upload,
			},
			...[small ? 'h-6 px-5' : 'h-9'],
			`${backgroundColor}`,
			'text-sm font-medium',
			'font-noto rounded px-2.5 text-white transition',
			'hover:opacity-90',
			'flex items-center justify-center'
		]"
		:style="builderStyles ? button : {}"
	>
		<div
			v-if="$slots.icon"
			class="mr-1"
		>
			<slot
				name="icon"
				:style="builderStyles ? buttonIcon : {}"
			/>
		</div>
		<slot />
	</button>
</template>

<script>
import { storeToRefs } from 'pinia';
import { useBuilderStyles } from '../store/builder-style.store';

export default {
	props: {
		isDisabled: {
			type: Boolean,
			default: false,
		},
		ghost: {
			type: Boolean,
			default: false,
		},
		upload: {
			type: Boolean,
			default: false,
		},
		small: {
			type: Boolean,
			default: false,
		},

		builderStyles: {
			type: Boolean,
			default: false,
		},
		backgroundColor: {
			type: String,
			default: 'won-green-background-color'
		},
	},

	setup({ builderStyles }) {
		if (!builderStyles) {
			return {};
		}

		const styles = useBuilderStyles();
		const { button, buttonIcon } = storeToRefs(styles);

		return {
			button,
			buttonIcon,
		};
	},
};
</script>


